var map = {
	"./AD.svg": 183,
	"./AE.svg": 184,
	"./AF.svg": 185,
	"./AG.svg": 186,
	"./AI.svg": 187,
	"./AL.svg": 188,
	"./AM.svg": 189,
	"./AN.svg": 190,
	"./AO.svg": 191,
	"./AR.svg": 192,
	"./AT.svg": 193,
	"./AU.svg": 194,
	"./AW.svg": 195,
	"./AX.svg": 196,
	"./AZ.svg": 197,
	"./BA.svg": 198,
	"./BB.svg": 199,
	"./BD.svg": 200,
	"./BE.svg": 201,
	"./BF.svg": 202,
	"./BG.svg": 203,
	"./BH.svg": 204,
	"./BI.svg": 205,
	"./BJ.svg": 206,
	"./BM.svg": 207,
	"./BN.svg": 208,
	"./BO.svg": 209,
	"./BR.svg": 210,
	"./BS.svg": 211,
	"./BT.svg": 212,
	"./BW.svg": 213,
	"./BY.svg": 214,
	"./BZ.svg": 215,
	"./CA.svg": 216,
	"./CAF.svg": 217,
	"./CAS.svg": 218,
	"./CD.svg": 219,
	"./CEU.svg": 220,
	"./CF.svg": 221,
	"./CG.svg": 222,
	"./CH.svg": 223,
	"./CI.svg": 224,
	"./CL.svg": 225,
	"./CM.svg": 226,
	"./CN.svg": 227,
	"./CNA.svg": 228,
	"./CO.svg": 229,
	"./COC.svg": 230,
	"./CR.svg": 231,
	"./CSA.svg": 232,
	"./CU.svg": 233,
	"./CV.svg": 234,
	"./CY.svg": 235,
	"./CZ.svg": 236,
	"./DE.svg": 237,
	"./DJ.svg": 238,
	"./DK.svg": 239,
	"./DM.svg": 240,
	"./DO.svg": 241,
	"./DZ.svg": 242,
	"./EC.svg": 243,
	"./EE.svg": 244,
	"./EG.svg": 245,
	"./ER.svg": 246,
	"./ES.svg": 247,
	"./ET.svg": 248,
	"./EU.svg": 249,
	"./FI.svg": 250,
	"./FJ.svg": 251,
	"./FK.svg": 252,
	"./FM.svg": 253,
	"./FR.svg": 254,
	"./GA.svg": 255,
	"./GB.svg": 256,
	"./GD.svg": 257,
	"./GE.svg": 258,
	"./GG.svg": 259,
	"./GH.svg": 260,
	"./GI.svg": 261,
	"./GM.svg": 262,
	"./GN.svg": 263,
	"./GQ.svg": 264,
	"./GR.svg": 265,
	"./GT.svg": 266,
	"./GW.svg": 267,
	"./GY.svg": 268,
	"./HK.svg": 269,
	"./HN.svg": 270,
	"./HR.svg": 271,
	"./HT.svg": 272,
	"./HU.svg": 273,
	"./ID.svg": 274,
	"./IE.svg": 275,
	"./IL.svg": 276,
	"./IM.svg": 277,
	"./IN.svg": 278,
	"./IQ.svg": 279,
	"./IR.svg": 280,
	"./IS.svg": 281,
	"./IT.svg": 282,
	"./JM.svg": 283,
	"./JO.svg": 284,
	"./JP.svg": 285,
	"./KE.svg": 286,
	"./KG.svg": 287,
	"./KH.svg": 288,
	"./KM.svg": 289,
	"./KN.svg": 290,
	"./KP.svg": 291,
	"./KR.svg": 292,
	"./KW.svg": 293,
	"./KY.svg": 294,
	"./KZ.svg": 295,
	"./LA.svg": 296,
	"./LB.svg": 297,
	"./LC.svg": 298,
	"./LI.svg": 299,
	"./LK.svg": 300,
	"./LR.svg": 301,
	"./LS.svg": 302,
	"./LT.svg": 303,
	"./LU.svg": 304,
	"./LV.svg": 305,
	"./LY.svg": 306,
	"./MA.svg": 307,
	"./MC.svg": 308,
	"./MD.svg": 309,
	"./ME.svg": 310,
	"./MG.svg": 311,
	"./MK.svg": 312,
	"./ML.svg": 313,
	"./MM.svg": 314,
	"./MN.svg": 315,
	"./MO.svg": 316,
	"./MR.svg": 317,
	"./MS.svg": 318,
	"./MT.svg": 319,
	"./MU.svg": 320,
	"./MV.svg": 321,
	"./MW.svg": 322,
	"./MX.svg": 323,
	"./MY.svg": 324,
	"./MZ.svg": 325,
	"./NA.svg": 326,
	"./NE.svg": 327,
	"./NG.svg": 328,
	"./NI.svg": 329,
	"./NL.svg": 330,
	"./NO.svg": 331,
	"./NP.svg": 332,
	"./NZ.svg": 333,
	"./OM.svg": 334,
	"./PA.svg": 335,
	"./PE.svg": 336,
	"./PF.svg": 337,
	"./PG.svg": 338,
	"./PH.svg": 339,
	"./PK.svg": 340,
	"./PL.svg": 341,
	"./PR.svg": 342,
	"./PT.svg": 343,
	"./PW.svg": 344,
	"./PY.svg": 345,
	"./QA.svg": 346,
	"./RO.svg": 347,
	"./RS.svg": 348,
	"./RU.svg": 349,
	"./RW.svg": 350,
	"./SA.svg": 351,
	"./SB.svg": 352,
	"./SC.svg": 353,
	"./SD.svg": 354,
	"./SE.svg": 355,
	"./SG.svg": 356,
	"./SH.svg": 357,
	"./SI.svg": 358,
	"./SK.svg": 359,
	"./SL.svg": 360,
	"./SM.svg": 361,
	"./SN.svg": 362,
	"./SO.svg": 363,
	"./SR.svg": 364,
	"./ST.svg": 365,
	"./SV.svg": 366,
	"./SY.svg": 367,
	"./SZ.svg": 368,
	"./TC.svg": 369,
	"./TD.svg": 370,
	"./TG.svg": 371,
	"./TH.svg": 372,
	"./TJ.svg": 373,
	"./TL.svg": 374,
	"./TM.svg": 375,
	"./TN.svg": 376,
	"./TO.svg": 377,
	"./TR.svg": 378,
	"./TT.svg": 379,
	"./TW.svg": 380,
	"./TZ.svg": 381,
	"./UA.svg": 382,
	"./UG.svg": 383,
	"./US.svg": 384,
	"./UY.svg": 385,
	"./UZ.svg": 386,
	"./VC.svg": 387,
	"./VE.svg": 388,
	"./VG.svg": 389,
	"./VN.svg": 390,
	"./VU.svg": 391,
	"./WS.svg": 392,
	"./WW.svg": 393,
	"./YE.svg": 394,
	"./ZA.svg": 395,
	"./ZM.svg": 396,
	"./ZW.svg": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags ^\.\/.*\.svg$
// module id = 593
// module chunks = 0